<div #itemEle class="relative" [class.hovering]="isHoverEnabled" (mouseenter)="mouseenter($event)"
    (mouseleave)="mouseleave($event)" (click)="menuItemClick($event)" [ngClass]="pageType">
    <button routerLinkActive="active" type="button" (click)="clickMenuItem($event,data)"
        class="menu-item relative inline-flex py-6 lg-custom:py-3 -mt-6 text-white tracking-[-0.5px] text-sm w-full lg-custom:w-auto transition-all "
        [class.has-sub-menu]="data?.subMenu.length > 0" [class.sticky-enabled]="isStickyEnabled">
        <span class="relative inner-item w-full lg-custom:w-auto ">
            <span class="flex justify-between">
                <div
                    class="w-full relative text-[14px] flex items-center tracking-wide ltr:hover:tracking-normal transition-all ltr:hover:font-[570] rtl:hover:font-[650]">
                    <span *ngIf="!data.link">{{data.title}}</span>
                    <ng-container *ngIf="data.link">

                        <ng-container *ngIf="isExternalMethod(data.link)">
                            <a *ngIf="data.linkTarget === '_blank'" target="_blank" class="ltr:text-left rtl:text-right w-full" (click)="closeMenu()"
                                [href]="data.link | routeLocalization">{{data.title}}<span
                                    class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                    more about this button</span></a>

                            <a *ngIf="data.linkTarget !== '_blank'" class="ltr:text-left rtl:text-right w-full" (click)="closeMenu()"
                                [href]="data.link | routeLocalization">{{data.title}}<span
                                    class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                    more about this button</span></a>
                        </ng-container>


                        <ng-container *ngIf="!isExternalMethod(data.link)">
                            <a *ngIf="data.linkTarget === '_blank'" target="_blank" class="ltr:text-left rtl:text-right w-full" (click)="closeMenu()"
                                [href]="data.link | routeLocalization">{{data.title}}<span
                                    class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                    more about this button</span></a>

                            <a *ngIf="data.linkTarget !== '_blank'" class="ltr:text-left rtl:text-right w-full" (click)="closeMenu()"
                                [routerLink]="data.link | routeLocalization">{{data.title}}<span
                                    class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                    more about this button</span></a>
                        </ng-container>



                    </ng-container>



                    <span *ngIf="data.isNew && isPromotionAndThereIsItemsNotVisited(data?.link)"
                        class="new-item absolute ltr:left-[59px] ltr:right-auto rtl:left-auto rtl:right-[75px] lg:ltr:right-0 lg:ltr:left-auto lg:rtl:left-0 lg:rtl:right-auto px-1 h-[11px] flex rounded-[3px] items-center justify-center -top-2.5 tracking-[-0.29px] font-Poppins-Light text-[0.5rem] animate-[bounce_1s_ease_infinite]">{{'SHARED.NEW'
                        | translate}}</span>
                </div>
                <span *ngIf="data?.subMenu.length > 0" class="transition-all ltr:ml-1 rtl:mr-1">
                    <app-svg src="assets/svgs/arrow.svg" customClass="" label="title_goas_here" [stretch]="false"
                        width="21" height="21" stroke="white"></app-svg>
                </span>
            </span>
        </span>
    </button>

    <div #subMenuItem *ngIf="data?.subMenu.length > 0" [attr.id]="id" [style.left.px]="leftPosition"
        class="sub-menu relative lg-custom:absolute top-0 lg-custom:top-[28px] bg-white rounded-[5px] flex-col lg-custom:flex-row hidden w-[calc(100%+38px)] lg-custom:min-w-[300px] lg-custom:w-auto shadow-custom-5 mb-8 lg-custom:mb-0 z-10"
        (click)="$event.stopPropagation();">
        <ng-container *ngFor="let subMenuInner of data?.subMenu">
            <div class="menu-with-title flex flex-col gap-4 px-4 ltr:lg-custom:pl-8 rtl:lg-custom:pr-8 py-4 lg-custom:pt-[50px] lg-custom:pb-8 w-max"
                *ngIf="subMenuInner?.menuWithTitle">
                <app-menu-item-list-title *ngFor="let menu of subMenuInner?.menuWithTitle" [title]="menu.title"
                    [link]="menu.link" [linkTarget]="menu.linkTarget" [menu]="menu.list"
                    (closeMobileMenu)="closeMenu()"></app-menu-item-list-title>
            </div>
            <div class="bg-[#EDFFF6] w-[calc(100%-1rem)] lg-custom:w-[258px] flex rounded-[6px] mx-auto lg-custom:mx-5 mt-5 mb-8"
                *ngIf="subMenuInner?.menuDescription"
                [class.white-bg]="subMenuInner?.menuDescription?.img && subMenuInner?.menuDescription?.btn?.link && subMenuInner?.menuDescription?.btn?.text && !subMenuInner?.menuDescription?.title && !subMenuInner?.menuDescription?.desc">
                <app-menu-item-our-story class="w-full" [data]="subMenuInner?.menuDescription"
                    (onCloseHeaderClick)="closeMenu()"></app-menu-item-our-story>
            </div>

        </ng-container>

    </div>
</div>